/**
 * Rock BTS photo workflow (REQ-03 / report page 2).
 *
 * Reuses the free-form category model from the triaxial photos tab
 * (Photo.Stage = category id, Photo.Position = 1-based index). BTS needs
 * before/after per specimen; the visible category list adapts to the
 * test's specimen count, and labels match the golden reports' captions
 * ("Specimen Before Testing" vs "Specimen 1 of 2 Before Testing").
 *
 * The report consumes the FIRST photo (lowest Position) of each category.
 */

export type RockBtsPhotoCategoryId = 'bts-s1-before' | 'bts-s1-after' | 'bts-s2-before' | 'bts-s2-after';

export interface RockBtsPhotoCategory {
  id: RockBtsPhotoCategoryId;
  label: string;
  description: string;
}

/** Category list + report captions for the given specimen count (1 | 2). */
export const rockBtsPhotoCategories = (specimenCount: number): RockBtsPhotoCategory[] => {
  if (specimenCount >= 2) {
    return [
      { id: 'bts-s1-before', label: 'Specimen 1 of 2 Before Testing', description: 'Specimen 1 prior to loading.' },
      { id: 'bts-s1-after',  label: 'Specimen 1 of 2 After Testing',  description: 'Specimen 1 after failure.' },
      { id: 'bts-s2-before', label: 'Specimen 2 of 2 Before Testing', description: 'Specimen 2 prior to loading.' },
      { id: 'bts-s2-after',  label: 'Specimen 2 of 2 After Testing',  description: 'Specimen 2 after failure.' },
    ];
  }
  return [
    { id: 'bts-s1-before', label: 'Specimen Before Testing', description: 'The specimen prior to loading.' },
    { id: 'bts-s1-after',  label: 'Specimen After Testing',  description: 'The specimen after failure.' },
  ];
};
